// Returns correct `relatedTarget` and `currentTarget` for every browser

export const getEventTargets = e => {
  const {
    relatedTarget,
    currentTarget
  } = e;
  return {
    relatedTarget,
    currentTarget
  };
};
// Checks if blur event happened in same target
export const focusInCurrentTarget = (e, excludedRef) => {
  const {
    relatedTarget,
    currentTarget
  } = getEventTargets(e);
  if (excludedRef && excludedRef.current && excludedRef.current.contains(relatedTarget)) {
    return true;
  }
  if (relatedTarget === null) {
    return false;
  }
  let node = relatedTarget.parentNode;
  while (node !== null) {
    if (node === currentTarget) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};